import React from 'react';
import PropTypes from 'prop-types';
import { Highlight } from 'react-instantsearch';

import BaseCard from '../BaseCard';
import getFavoriteHook from '@hooks/getFavoriteHook';

const EventCard = props => {
    const {
        hit,
        id,
        title,
        image,
        dateRange,
        isFavorite: initialIsFavorite,
        favorited = () => {},
        onClick = () => {},
        url,
        isLoggedIn,
    } = props;

    const useFavorite = getFavoriteHook({ type: 'event', initialIsFavorite });
    const { isFavorite, isLoadingFavorite, saveFavorite, removeFavorite } = useFavorite();

    const onFavorite = () => {
        if (isFavorite) {
            removeFavorite(id);
        } else {
            saveFavorite(id);
            favorited({ hit });
        }
    };

    const imageBlock = (
        <>
            <a href={url} onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="card-link">
                <img className="card-img-top w-100" src={image || '/assets/images/pattern-white.svg'} alt={title} />
            </a>
        </>
    );

    const titleSpacingClasses = 'mt-4';

    return (
        <BaseCard
            cardClasses="event-card"
            id={id}
            type="event"
            title={title}
            url={url}
            onClick={onClick}
            isFavorite={isFavorite}
            onFavorite={onFavorite}
            isLoadingFavorite={isLoadingFavorite}
            imageBlock={imageBlock}
            isLoggedIn={isLoggedIn}
            contentBlock={
                <>
                    <a href={url} onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="card-link">
                        <h3 className={`card-title d6-truncate3 display6 truncate-lines bold ${titleSpacingClasses}`}>
                            <Highlight
                                attribute="title"
                                hit={hit}
                                classNames={{ highlighted: 'bg-highlight text-admiral p-0' }}
                            />
                        </h3>
                        {dateRange && <p className="display8 secondary mt-3 mt-md-5 mt-lg-3 mb-0 py-0">{dateRange}</p>}
                        {hit.location && (hit.location.city || hit.location.state) && (
                            <p className="display8 secondary mt-4 mb-0 py-0">
                                {hit.location && (
                                    <>
                                        {hit.location.city && (
                                            <Highlight
                                                attribute="location.city"
                                                hit={hit}
                                                classNames={{ highlighted: 'bg-highlight text-admiral p-0' }}
                                            />
                                        )}
                                        {hit.location.city && hit.location.state && ', '}
                                        {hit.location.state && (
                                            <Highlight
                                                attribute="location.state"
                                                hit={hit}
                                                classNames={{ highlighted: 'bg-highlight text-admiral p-0' }}
                                            />
                                        )}
                                    </>
                                )}
                            </p>
                        )}
                    </a>
                </>
            }
        />
    );
};

EventCard.propTypes = {
    hit: PropTypes.object.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    dateRange: PropTypes.string,
    url: PropTypes.string,
    isFavorite: PropTypes.bool.isRequired,
    favorited: PropTypes.func,
    onClick: PropTypes.func,
    isLoggedIn: PropTypes.bool,
};

export default EventCard;
